export const GOOGLE_PROFILE_URL = "https://share.google/rqEifT0MdUeKSuCS2";
export const GOOGLE_REVIEW_URL =
  "https://www.google.com/maps/place/Modify+Home+Safety+Modifications/@-32.0400639,115.9615356,17z/data=!4m6!3m5!1s0x85b14e668f7e6af9:0xa1169c6186a1b7e9!8m2!3d-32.0400639!4d115.9615356!16s%2Fg%2F11vdmdcrlw";
export const GOOGLE_RATING = 5.0;
export const GOOGLE_REVIEW_COUNT = 5;

export const MANUAL_REVIEWS = [
  {
    author: "Peter Stickells",
    time: "3 months ago",
    rating: 5,
    text: "I had safety rails fitted — one in our shower and one by our toilet. Very pleased with the results: they arrived on time, did a great job and were very professional going about the work.",
  },
  {
    author: "Janet Barron",
    time: "3 months ago",
    rating: 5,
    text: "Wonderful service, absolute pleasure to deal with and they did a great job. Very impressed.",
  },
  {
    author: "Kaser K.",
    time: "3 months ago",
    rating: 5,
    text: "Aldo and Luke from Modify are amazing. Very professional, and they also do the little extra things. Very patient explaining how everything works and what was best for me. This is the second job they have completed for me and I will definitely get them back again.",
  },
  {
    author: "Peter de San Miguel",
    time: "3 months ago",
    rating: 5,
    text: "Excellent and professional workmanship installing multiple grab rails.",
  },
  {
    author: "John & Marge Dale",
    time: "2 months ago",
    rating: 5,
    text: "Prompt to attend and quote, job completed in two days. Aldo and Luke very friendly and approachable, explained everything and the job was completed. Wouldn't hesitate to use them again.",
  },
];
